import { formatInTimeZone } from 'date-fns-tz'
import { transformBooking } from './booking'
import type { BookingRefunded } from '@/types/refunded'
import type { InfiniteData } from '@tanstack/react-query'
import type { refundedService } from '@/services/refunded'
import { TIMEZONE } from '@/utils/constant'

const transformRefund = (booking: BookingRefunded) => {
  const _label_requested_date = booking.requested_date
    ? formatInTimeZone(
        booking.requested_date,
        TIMEZONE.DEFAULT,
        'dd MMMM yyyy, hh:mm a',
      )
    : '-'
  const _label_payment_date = booking.payment_date
    ? formatInTimeZone(
        booking.payment_date,
        TIMEZONE.DEFAULT,
        'dd MMMM yyyy, hh:mm a',
      )
    : '-'

  return {
    ...booking,
    adhoc_booking: transformBooking(booking.adhoc_booking),
    _label_requested_date,
    _label_payment_date,
  }
}

export const selectionBookingRefundeds = (
  res: InfiniteData<Awaited<ReturnType<typeof refundedService.list>>>,
) => {
  return {
    ...res,
    pages: res.pages.map((page) => ({
      ...page,
      data: {
        refunds: page.data.refunds.map((refund) => transformRefund(refund)),
      },
    })),
  }
}

export const selectionRefunded = (
  res: Awaited<ReturnType<typeof refundedService.detail>>,
) => ({
  ...res,
  data: {
    ...res.data,
    refund: transformRefund(res.data.refund),
  },
})
